import { lazy, Suspense } from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import InfoBanner from '@/components/InfoBanner';
import CastlePromoPopup from '@/components/CastlePromoPopup';

// Lazy load below-the-fold components to reduce initial bundle size
const AboutSection = lazy(() => import('@/components/AboutSection'));
const SeafoodSection = lazy(() => import('@/components/SeafoodSection'));
const MenuSection = lazy(() => import('@/components/MenuSection'));
const GallerySection = lazy(() => import('@/components/GallerySection'));
const ReviewsSection = lazy(() => import('@/components/ReviewsSection'));
const SuppliersSection = lazy(() => import('@/components/SuppliersSection'));
const ContactSection = lazy(() => import('@/components/ContactSection'));
const Footer = lazy(() => import('@/components/Footer'));
const BottomBanners = lazy(() => import('@/components/BottomBanners'));

const Index = () => {
  return (
    <main className="min-h-screen">
      <Header />
      <HeroSection />
      <Suspense fallback={null}>
        <AboutSection />
        <SeafoodSection />
        <MenuSection />

        <GallerySection />
        <ReviewsSection />
        <SuppliersSection />
        <ContactSection />
        <Footer />
        <BottomBanners />
        {/* Desktop/tablette : popups fixes dans les coins */}
        <div className="hidden sm:fixed sm:block sm:bottom-4 sm:left-4 sm:z-50">
          <InfoBanner />
        </div>
        <div className="hidden sm:fixed sm:block sm:bottom-4 sm:right-4 sm:z-50">
          <CastlePromoPopup />
        </div>
      </Suspense>
    </main>
  );
};

export default Index;
